import {isIE} from '../../../utility/js/tests';

(function () {
    var autoHideBar = {
        headerSelector: '.header',
        $primaryBar: $('.auto-hide-primary-bar'),
        $stickyBar: $('.auto-hide-secondary-bar'),
        previousTop: 0,
        scrollDelta: 5,
        scrollOffset: 100,
        vPort: 'screen-sm',
        isMobile: false,
        previousScroll: '',
        disabled: false,
        changeEvent: null,
        changeEventName: 'change:auto-hide-bar',

        init: function () {
            if (!isIE) {
                this.header = document.querySelector(this.headerSelector);
                this.$primaryBar.addClass('auto-hide-bar fixed-element');
                this.$stickyBar.addClass('secondary-bar--sticky fixed-element');

                this.createEvents();

                setTimeout(() => {
                    this.$stickyBar.css('top', this.$primaryBar.height());
                }, 200);

                this.control();
            } else {
                this.$primaryBar.removeClass('fixed');
            }
        },
        control: function () {
            $(document).on(autoHideBar.vPort + '-on', function () {
                // Waiting for custom event that will be triggered by controller.js to activate responsive effects
                autoHideBar.isMobile = true;
            });

            $(document).on(autoHideBar.vPort + '-off', function () {
                // Waiting for custom event that will be triggered by controller.js to deactivate responsive effects
                autoHideBar.isMobile = false;
            });

            $(window).on('resize', function () {
                autoHideBar.previousScroll = '';
            });
            $(window).on('scroll resize', () => {
                autoHideBar.displayOnScroll();
            });

            autoHideBar.additionalControls();
        },
        createEvents() {
            this.changeEvent = new CustomEvent(this.changeEventName, {}, false);
        },
        displayOnScroll: function () {
            if (autoHideBar.$stickyBar.length && autoHideBar.isMobile === false && !autoHideBar.disabled) {
                const currentTop = $(window).scrollTop();
                const secondaryNav_HeaderOffsetTop = autoHideBar.$primaryBar.height() + autoHideBar.scrollOffset;

                if (autoHideBar.previousTop >= currentTop && currentTop < secondaryNav_HeaderOffsetTop) {
                    //if scrolling up...
                    if (
                        autoHideBar.previousTop - currentTop > autoHideBar.scrollDelta &&
                        autoHideBar.previousScroll !== 'up'
                    ) {
                        autoHideBar.$primaryBar.addClass('fixed-element');
                        this.header.style.removeProperty('transform');
                        autoHideBar.previousScroll = 'up';
                        setTimeout(() => {
                            document.dispatchEvent(this.changeEvent);
                        }, 100);
                    }
                } else if (currentTop > secondaryNav_HeaderOffsetTop && autoHideBar.previousScroll !== 'down') {
                    //if scrolling down...
                    autoHideBar.$primaryBar.removeClass('fixed-element');
                    this.header.style.setProperty('transform', `translateY(-${autoHideBar.$primaryBar.height()}px)`);
                    autoHideBar.hideOpenHeaderMenus();
                    autoHideBar.previousScroll = 'down';
                    setTimeout(() => {
                        document.dispatchEvent(this.changeEvent);
                    }, 100);
                }
                autoHideBar.previousTop = currentTop;
            }
        },
        additionalControls: function () {},
        hideOpenHeaderMenus: function () {
            //hide profile menu
            $('.navigation-login-dropdown-container').addClass('hidden');
            //hide login menu
            const $openedLoginMenu = $('.loginBar__dropBlock__holder.js--open');
            $openedLoginMenu.removeClass('js--open');
            $('[data-db-target-for=' + $openedLoginMenu.attr('data-db-target-of') + ']').removeClass('js--open');
            //hide quick search menu
            const $openedQuickSearchMenu = $('.quick-search__dropBlock.js--open');
            $openedQuickSearchMenu.removeClass('js--open');
            $('[data-db-target-for=' + $openedQuickSearchMenu.attr('data-db-target-of') + ']').removeClass('js--open');
        },
    };

    UX.autoHideBar = autoHideBar; // add to global namespace
})();
